import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import { createMachine } from "xstate";
import { useInterpret } from "xstate-vue2";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useApplicationVisibilityState } from "@Client/@Composables/application-standalone/machine/useApplicationVisibilityState";
import { computed, ref, watch } from "@vue/composition-api";
export const useApplicationStepMachine = () => {
  const {
    visibilityState
  } = useApplicationVisibilityState();
  const stateMachineDefinitions = computed(() => {
    var _context;
    return _reduceInstanceProperty(_context = visibilityState.value).call(_context, (acc, current, index, list) => {
      const allOtherPages = _reduceInstanceProperty(list).call(list, (pages, currentItem) => {
        if (currentItem.name !== current.name) pages = _objectSpread(_objectSpread({}, pages), {}, {
          [currentItem.name]: {
            target: currentItem.name
          }
        });
        return pages;
      }, {});
      if (index === 0 && list[index + 1]) {
        acc[current.name] = {
          on: _objectSpread({
            NEXT: {
              target: list[index + 1].name
            }
          }, allOtherPages)
        };
        return acc;
      }
      if (index === list.length - 1 && list[index - 1]) {
        acc[current.name] = {
          on: _objectSpread({
            PREV: {
              target: list[index - 1].name
            }
          }, allOtherPages)
        };
        return acc;
      }
      if (list[index + 1] && list[index - 1]) {
        acc[current.name] = {
          on: _objectSpread({
            NEXT: {
              target: list[index + 1].name
            },
            PREV: {
              target: list[index - 1].name
            }
          }, allOtherPages)
        };
      } else {
        acc[current.name] = {};
      }
      return acc;
    }, {});
  });
  const service = ref();
  const letOff = computed(() => {
    return APPLICATION_STEPS.SUBMIT;
  });
  const currentStep = computed(() => {
    var _service$value;
    return (_service$value = service.value) == null ? void 0 : _service$value.state.value;
  });
  watch(stateMachineDefinitions, (states, prevStates = {}) => {
    const initial = _Object$keys(prevStates).length === 1 || !currentStep.value ? letOff.value : currentStep.value;
    const machine = createMachine({
      initial,
      states
    });
    service.value = useInterpret(machine);
    service.value.start();
  }, {
    immediate: true
  });
  return {
    stateMachineDefinitions,
    machineInstance: service,
    currentStep
  };
};